var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 170 171"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 85.5,
    r: 37.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M81.072 20.91c.832-4.325 7.023-4.325 7.856 0l2.382 12.38a4 4 0 0 1-3.928 4.756h-4.765a4 4 0 0 1-3.928-4.756zM88.928 150.09c-.832 4.325-7.023 4.325-7.856 0l-2.382-12.38a4 4 0 0 1 3.928-4.756h4.765a4 4 0 0 1 3.928 4.756zM127.895 37.052c3.647-2.47 8.025 1.907 5.555 5.554l-7.07 10.44a4 4 0 0 1-6.14.585l-3.369-3.37a4 4 0 0 1 .585-6.14zM42.106 133.95c-3.648 2.47-8.025-1.907-5.555-5.554l7.069-10.439a4 4 0 0 1 6.14-.586l3.37 3.37a4 4 0 0 1-.586 6.14zM149.59 81.572c4.325.832 4.325 7.023 0 7.856l-12.38 2.382a4 4 0 0 1-4.756-3.928v-4.765a4 4 0 0 1 4.756-3.928zM20.41 89.428c-4.325-.832-4.325-7.023 0-7.856l12.38-2.382a4 4 0 0 1 4.756 3.928v4.765a4 4 0 0 1-4.756 3.928zM133.449 128.395c2.47 3.647-1.907 8.025-5.554 5.555l-10.439-7.069a4 4 0 0 1-.586-6.14l3.37-3.37a4 4 0 0 1 6.14.586zM36.55 42.607c-2.47-3.648 1.908-8.025 5.555-5.555l10.44 7.069a4 4 0 0 1 .585 6.14l-3.37 3.37a4 4 0 0 1-6.14-.586z"
  })));
};
export default SvgSun;